module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Price")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("价格")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("颜色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#f02f45")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("font_size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("字号大小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("24")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("super")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("价格符号是否对其文本的上标")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("delete")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否为"), _c('code', [_vm._v("Del")]), _vm._v("样式")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("suffix")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("后缀文本")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String/Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("text_size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("文本和符号大小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("no_shrink")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("文本和符号价格符号不缩小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("symbol")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("价格符号")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("￥")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c22624c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/index-9.vue
// module id = 633
// module chunks = 0